/**
 * Copyright 2018, CLOUDPILOTS Software & Consulting GmbH
 *
 * React entry point for react-app
 * @default
 *
 */

import "./app";



// WEBPACK FOOTER //
// ./src/index.js